import Toggle from '../toggle/toggle.js';
import { Cursor } from '../animations/index.js';

export default class Panels {

	constructor() {
		this.init();
    this.bind();
	}

	init() {
    this.controls = Toggle.init(
			'[data-panel-btn]',
			'[data-panel-target]',
			document.body,
			'active',
      this.onToggle.bind(this),
      true //touchevent for mobile
		);
	}

  bind() {
    this.items = Array.from(document.querySelectorAll('[data-panel-target]'));
    this.items.forEach(item => Cursor.init(item));
  }

  onToggle(e) {
    const panelName = e.item.target.dataset.panelTarget;
    const selector = `.scroll-blocker[data-panel-btn="${panelName}"]`;
    const bodyClass = `_${panelName}-panel`;
    const panel = document.body.querySelector(selector);
    panel.classList.toggle('_dark');
    this.activePanel = {
      node: panel,
      bodyClass: bodyClass
    };
    if(document.body.classList.contains(bodyClass)){
      document.body.classList.remove(bodyClass);
      window.client.scroller.start();
    } else {
      document.body.classList.add(bodyClass);
      window.client.scroller.stop();
      this.setFormValues(e.item);
    }
  }

  setFormValues(item) {
    const dataText = item.node.dataset.panelText;
    const dataId = item.node.dataset.panelId;
    const target = item.target;
    const title = target.querySelector('.panel__title span');
    const hiddenInput = target.querySelector(`#${dataId}`);
    if (title && hiddenInput) {
      if (dataText && dataId) {
        title.innerHTML = dataText
        hiddenInput.value = dataText;
      } else {
        title.innerHTML = ''
        hiddenInput.value = '';
      }
    }

  }

  destroy() {
    Toggle.destroyAll(this.controls);
    window.client.scroller.start();
    if (this.activePanel) {
      this.activePanel.node.classList.remove('_dark');
      document.body.classList.remove(this.activePanel.bodyClass);
    }
  }
}
